<template>
  <div id="fuDanEhallCard">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>月车</el-breadcrumb-item>
          <el-breadcrumb-item>复旦月卡管理</el-breadcrumb-item>
          <el-breadcrumb-item>外协车辆管理</el-breadcrumb-item>
          <el-breadcrumb-item>外协车辆列表</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               class="pageSearch">
        <!--<el-form-item label="客户名称::">
          <el-select v-model="selCustID"
                     filterable
                     clearable
                     @change="changeCust"
                     placeholder="请选择客户">
            <el-option v-for="item in choiceCusts"
                       :key="item.fCustID"
                       :label="item.unionName"
                       :value="item.fCustID">
            </el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item label="关键字::">
          <el-input placeholder="请输入车牌号/车主姓名/手机号"
                    v-model="searchKeyWord"
                    class="input-with-select">
          </el-input>
        </el-form-item>
        <el-form-item label="">
            <el-checkbox v-model="effectiveVehicle">有效车辆</el-checkbox>
          </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     size="small"
                     @click="cardQuery">查询</el-button>
          <el-button type="success"
                     size="small"
                     icon="el-icon-share"
                     :loading="export_loading"
                     v-if="is_export"
                     @click="exportData">{{export_msg}}</el-button>
          <el-button size="mini"
                      type="warning"
                      @click="setEhallCardDefaultChnl"
                      v-if="is_edit">设置默认进场通道</el-button>
        </el-form-item>
        <el-form-item style="float:right;margin-right:0px;">
          <el-button type="primary"
                     size="small"
                     @click="addSyncEhallCard"
                     v-if="is_edit">新增外协车</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-tabs v-model="cardActiveName"
               type="card"
               @tab-click="tabClick">
          <el-row>
            <el-table :data="cardList"
                      border
                      v-loading="loading"
                      highlight-current-row
                      style="width: 100%"
                      :height="tableHeight"
                      ref="singleTable">
              <el-table-column type="index"
                               width="50"
                               label="序号"
                               :index="indexMethod">
              </el-table-column>
              <!--<el-table-column prop="fOpLastTime"
                               width="180"
                               label="最后同步时间">
              </el-table-column>-->
              <!--<el-table-column prop="fCustNo"
                               width="80"
                               label="客户编号">
              </el-table-column>
              <el-table-column prop="fCustName"
                               width="200"
                               label="客户名称">
              </el-table-column>-->
              <el-table-column prop="fCardName"
                               width="100"
                               label="车主姓名">
              </el-table-column>
              <el-table-column prop="fPlateCode"
                               width="100"
                               label="车牌号码">
              </el-table-column>
              <el-table-column prop="fBatStartTimeTitle"
                               width="150"
                               label="起始时间">
              </el-table-column>
              <el-table-column prop="fBatEndTimeTitle"
                               width="150"
                               label="结束时间">
              </el-table-column>
              <el-table-column prop="fCardPhone"
                               width="130"
                               label="手机号码">
              </el-table-column>
              <el-table-column prop="fCardCreNo"
                               width="150"
                               label="证件号码">
              </el-table-column>
              <el-table-column prop="fFirUnit"
                               width="100"
                               label="一级单位">
              </el-table-column>
              <el-table-column prop="fSecUnit"
                               width="100"
                               label="二级单位">
              </el-table-column>
              <el-table-column prop="fThiUnit"
                               width="100"
                               label="三级单位">
              </el-table-column>
              <el-table-column prop="fCarTypeName"
                               width="115"
                               label="车辆类型">
              </el-table-column>
              <el-table-column prop="fDurationTitle"
                               width="110"
                               align="right"
                               label="剩余停车时数">
              </el-table-column>
              <el-table-column prop="fRemark"
                               label="备注">
              </el-table-column>
              <el-table-column fixed="right"
                               align="left"
                               label="操作"
                               width="315">
                <template slot-scope="scope">
                  <el-button @click="viewCard(scope.row)"
                             type="success"
                             size="mini">查看</el-button>
                  <el-button size="mini"
                             type="warning"
                             @click="editEhallCard(scope.$index, scope.row)"
                             v-if="is_edit">编辑</el-button>
                  <el-button size="mini"
                             type="danger"
                             @click="deleteEhallCardClient(scope.$index, scope.row)"
                             v-if="is_del">删除</el-button>
                  <el-popover placement="top">
                    <div style="text-align: right; margin: 0">
                      <el-button size="mini"
                             type="warning"
                             @click="rechargeCard(scope.$index, scope.row)"
                             v-if="is_recharge">充值</el-button>
                      <el-button size="mini"
                             type="success"
                             @click="rechargeEhallCardRecord(scope.$index, scope.row)">充值记录</el-button>
                      <el-button size="mini"
                             type="warning"
                             @click="addOrDedFDuration(scope.$index, scope.row)"
                             v-if="is_addOrDedFDuration">加减时数</el-button>
                      <el-button size="mini"
                             type="success"
                             @click="ehallCardInOutRecord(scope.$index, scope.row)">扣时/新增明细</el-button>
                    </div>
                    <el-button slot="reference"
                               size="mini">更多操作</el-button>
                  </el-popover>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
      </el-tabs>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageNo"
                         @current-change="handlePage"
                         :page-size="pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="total>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div class="userGroupEdit">
      <el-dialog :title="ehallCard.operateFlag"
                  v-dialogDrag
                  :visible.sync="dialogGroupFormVisible"
                  top="20vh"
                  left="0vh"
                  width="50%">
        <el-form :model="ehallCard"
                  :rules="groupRules"
                  ref="ehallCardForm"
                  label-width="115px">
          <el-row style="padding-top:10px;padding-left:10px;padding-right:10px">
            <el-col :span="8">
              <el-form-item label="车牌号码::" prop="fPlateCode">
                <el-input v-model="ehallCard.fPlateCode"
                          style="width: 100%"
                          :disabled="!groupIsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="车主名称::" prop="fCardName">
                <el-input v-model="ehallCard.fCardName"
                          style="width: 100%"
                          :disabled="!groupIsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="手机号码::" prop="fCardPhone">
                <el-input v-model="ehallCard.fCardPhone"
                          style="width: 100%"
                          :disabled="!groupIsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="padding-left:10px;padding-right:10px">
            <el-col :span="8">
              <el-form-item label="起始时间::"
                      prop="fBatStartTime">
                <el-date-picker v-model="ehallCard.fBatStartTime"
                                :disabled="!groupIsEdit"
                                style="width: 100%"
                                type="date"
                                :clearable="true"
                                placeholder="选择起始时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="结束时间::"
                      prop="fBatEndTime">
                <el-date-picker v-model="ehallCard.fBatEndTime"
                                :disabled="!groupIsEdit"
                                style="width: 100%"
                                type="date"
                                :clearable="true"
                                placeholder="选择起结束时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="证件号码::" prop="fCardCreNo">
                <el-input v-model="ehallCard.fCardCreNo"
                          style="width: 100%"
                          :disabled="!groupIsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="padding-left:10px;padding-right:10px">
            <el-col :span="8">
              <el-form-item label="一级单位::" prop="fFirUnit">
                <el-input v-model="ehallCard.fFirUnit"
                          style="width: 100%"
                          :disabled="!groupIsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="二级单位::" prop="fSecUnit">
                <el-input v-model="ehallCard.fSecUnit"
                          style="width: 100%"
                          :disabled="!groupIsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="三级单位::">
                <el-input v-model="ehallCard.fThiUnit"
                          style="width: 100%"
                          :disabled="!groupIsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="padding-left:10px;padding-right:10px">
            <el-col :span="8">
              <el-form-item label="车辆类型::" prop="fCarTypeID">
                <el-select v-model="ehallCard.fCarTypeID"
                      filterable
                      :disabled="!groupIsEdit"
                      sstyle="width: 100%">
                      <el-option
                      v-for="item in options1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="停车时数(小时)::" prop="fDuration">
                <el-input v-model="ehallCard.fDuration"
                          style="width: 100%"
                          :disabled="!groupIsEdit||!groupIsEdits"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="备注::" prop="fRemark">
                <el-input v-model="ehallCard.fRemark"
                          style="width: 100%"
                          :disabled="!groupIsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="padding-left:10px;padding-right:10px">
            <el-tabs type="border-card" style="height:300px">
            <el-tab-pane style="height:200px">
              <span slot="label"><i class="el-icon-news"></i> 绑定客户</span>
              <el-row style="padding-bottom: 10px">
                <el-col :span="10">
                  <el-input placeholder="请输入客户编号或名称"
                            v-model="bindQueryInput"
                            class="input-with-select">
                    <el-button slot="append"
                                icon="el-icon-search"
                                @click="bindQuery"></el-button>
                  </el-input>
                </el-col>
                <el-col :span="4">&nbsp;</el-col>
                <el-col :span="10">
                  <el-input placeholder="请输入客户编号或名称"
                            v-model="unbindQueryInput"
                            class="input-with-select">
                    <el-button slot="append"
                                icon="el-icon-search"
                                @click="unbindQuery"></el-button>
                  </el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="10">
                  <el-table :data="bindCustsUI"
                            border
                            height="200px"
                            style="width: 100%;"
                            highlight-current-row
                            @current-change="bindParkChange">
                    <el-table-column type="index"
                                      label="序号"
                                      width="50">
                    </el-table-column>
                    <el-table-column prop="unionName"
                                      label="绑定客户">
                    </el-table-column>
                  </el-table>
                </el-col>
                <el-col :span="4"
                        style="text-align: center;">
                  <el-row style="padding-top: 0px">
                    <el-col :span="24">
                      <el-button type="primary"
                                  icon="el-icon-d-arrow-left"
                                  style="width: 100px"
                                  @click="leftAllBtnClick"
                                  v-if="is_bind"
                                  :disabled="!groupIsEdit"></el-button>
                    </el-col>
                  </el-row>
                  <el-row style="padding-top: 15px">
                    <el-col :span="24">
                      <el-button type="primary"
                                  icon="el-icon-caret-left"
                                  style="width: 100px"
                                  @click="leftBtnClick"
                                  :disabled="!groupIsEdit"
                                  v-if="is_bind"></el-button>
                    </el-col>
                  </el-row>
                  <el-row style="padding-top: 15px">
                    <el-col :span="24">
                      <el-button type="primary"
                                  icon="el-icon-caret-right"
                                  style="width: 100px"
                                  @click="rightBtnClick"
                                  :disabled="!groupIsEdit"
                                  v-if="is_bind"></el-button>
                    </el-col>
                  </el-row>
                  <el-row style="padding-top: 15px">
                    <el-col :span="24">
                      <el-button type="primary"
                                  icon="el-icon-d-arrow-right"
                                  style="width: 100px"
                                  @click="rightAllBtnClick"
                                  v-if="is_bind"
                                  :disabled="!groupIsEdit"></el-button>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="10">
                  <el-table :data="unbindCustsUI"
                            border
                            height="200px"
                            style="width: 100%;"
                            highlight-current-row
                            @current-change="unbindParkChange">
                    <el-table-column type="index"
                                      label="序号"
                                      width="50">
                    </el-table-column>
                    <el-table-column prop="unionName"
                                      label="可选客户">
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane style="height:200px">
              <span slot="label"><i class="el-icon-news"></i>绑定进场通道</span>
              <el-row style="padding-bottom: 10px">
                <el-col :span="10">
                  <el-input placeholder="请输入通道名称"
                            v-model="bindChannelName"
                            class="input-with-select">
                    <el-button slot="append"
                              icon="el-icon-search"
                              @click="bindParkQuery"></el-button>
                  </el-input>
                </el-col>
                <el-col :span="4">&nbsp;</el-col>
                <el-col :span="10">
                  <el-input placeholder="请输入通道名称"
                            v-model="unbindChannelName"
                            class="input-with-select">
                    <el-button slot="append"
                              icon="el-icon-search"
                              @click="unbindParkQuery"></el-button>
                  </el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="10">
                  <el-table :data="cardBindChannelListUI"
                            border
                            height="200px"
                            highlight-current-row
                            @current-change="bindChnlChange">
                    <el-table-column type="index"
                                    label="序号"
                                    width="50">
                    </el-table-column>
                    <el-table-column prop="ParkNameWithChnlName"
                                    label="绑定停车场通道">
                    </el-table-column>
                  </el-table>
                </el-col>
                <el-col :span="4"
                        style="text-align: center;">
                  <el-row style="padding-top: 0px">
                    <el-col :span="24">
                      <el-button type="primary"
                                  icon="el-icon-d-arrow-left"
                                  style="width: 100px"
                                  @click="leftAllChlBtnClick"
                                  v-if="is_bind"
                                  :disabled="!groupIsEdit"></el-button>
                    </el-col>
                  </el-row>
                  <el-row style="padding-top: 15px">
                    <el-col :span="24">
                      <el-button type="primary"
                                icon="el-icon-caret-left"
                                style="width: 100px"
                                @click="leftChnlBtnClick"
                                :disabled="!groupIsEdit"></el-button>
                    </el-col>
                  </el-row>
                  <el-row style="padding-top: 15px">
                    <el-col :span="24">
                      <el-button type="primary"
                                icon="el-icon-caret-right"
                                style="width: 100px"
                                @click="rightChnlBtnClick"
                                :disabled="!groupIsEdit"></el-button>
                    </el-col>
                  </el-row>
                  <el-row style="padding-top: 15px">
                    <el-col :span="24">
                      <el-button type="primary"
                                  icon="el-icon-d-arrow-right"
                                  style="width: 100px"
                                  @click="rightAllChlBtnClick"
                                  v-if="is_bind"
                                  :disabled="!groupIsEdit"></el-button>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="10">
                  <el-table :data="cardUnBindChannelListUI"
                            border
                            height="200px"
                            highlight-current-row
                            @current-change="unbindChnlChange">
                    <el-table-column type="index"
                                    label="序号"
                                    width="50">
                    </el-table-column>
                    <el-table-column prop="ParkNameWithChnlName"
                                    label="可选停车场通道">
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
          </el-tab-pane>
          </el-tabs>
          </el-row>
        </el-form>
        <div slot="footer"
              class="dialog-footer">
          <el-button type="primary"
                    :loading="save_loading"
                      @click="submitForm('ehallCardForm')"
                      v-if="groupIsEdit">{{save_msg}}</el-button>
          <el-button @click="dialogGroupFormVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="userGroupEdit">
      <el-dialog :title="ehallCard.operateFlag"
                  v-dialogDrag
                  :visible.sync="dialogSetChnlFormVisible"
                  top="20vh"
                  left="0vh"
                  width="50%">
        <el-form :model="ehallCard"
                  ref="ehallCardForm"
                  label-width="115px">
          <el-row style="padding-top:10px;padding-left:10px;padding-right:10px">
            <el-tabs type="border-card" style="height:320px">
            <el-tab-pane style="height:220px">
              <span slot="label"><i class="el-icon-news"></i>绑定进场通道</span>
              <el-row style="padding-bottom: 10px">
                <el-col :span="10">
                  <el-input placeholder="请输入通道名称"
                            v-model="bindChannelName"
                            class="input-with-select">
                    <el-button slot="append"
                              icon="el-icon-search"
                              @click="bindParkQuery"></el-button>
                  </el-input>
                </el-col>
                <el-col :span="4">&nbsp;</el-col>
                <el-col :span="10">
                  <el-input placeholder="请输入通道名称"
                            v-model="unbindChannelName"
                            class="input-with-select">
                    <el-button slot="append"
                              icon="el-icon-search"
                              @click="unbindParkQuery"></el-button>
                  </el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="10">
                  <el-table :data="cardBindChannelListUI"
                            border
                            height="200px"
                            highlight-current-row
                            @current-change="bindChnlChange">
                    <el-table-column type="index"
                                    label="序号"
                                    width="50">
                    </el-table-column>
                    <el-table-column prop="ParkNameWithChnlName"
                                    label="绑定停车场通道">
                    </el-table-column>
                  </el-table>
                </el-col>
                <el-col :span="4"
                        style="text-align: center;">
                  <el-row style="padding-top: 0px">
                    <el-col :span="24">
                      <el-button type="primary"
                                  icon="el-icon-d-arrow-left"
                                  style="width: 100px"
                                  @click="leftAllChlBtnClick"></el-button>
                    </el-col>
                  </el-row>
                  <el-row style="padding-top: 15px">
                    <el-col :span="24">
                      <el-button type="primary"
                                icon="el-icon-caret-left"
                                style="width: 100px"
                                @click="leftChnlBtnClick"></el-button>
                    </el-col>
                  </el-row>
                  <el-row style="padding-top: 15px">
                    <el-col :span="24">
                      <el-button type="primary"
                                icon="el-icon-caret-right"
                                style="width: 100px"
                                @click="rightChnlBtnClick"></el-button>
                    </el-col>
                  </el-row>
                  <el-row style="padding-top: 15px">
                    <el-col :span="24">
                      <el-button type="primary"
                                  icon="el-icon-d-arrow-right"
                                  style="width: 100px"
                                  @click="rightAllChlBtnClick"></el-button>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="10">
                  <el-table :data="cardUnBindChannelListUI"
                            border
                            height="200px"
                            highlight-current-row
                            @current-change="unbindChnlChange">
                    <el-table-column type="index"
                                    label="序号"
                                    width="50">
                    </el-table-column>
                    <el-table-column prop="ParkNameWithChnlName"
                                    label="可选停车场通道">
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
          </el-tab-pane>
          </el-tabs>
          </el-row>
        </el-form>
        <div slot="footer"
              class="dialog-footer">
          <el-button type="primary"
                    :loading="save_loading"
                      @click="submitSetChnlForm('ehallCardSetChnlForm')">{{save_msg}}</el-button>
          <el-button @click="dialogSetChnlFormVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
    <el-dialog :title="dialogTitle"
               top="20vh"
               width="40%"
               v-dialogDrag
               :visible.sync="dialogFormVisible">
      <el-form :model="cardPay"
               :rules="rules"
               ref="ruleForm"
               label-width="115px">
        <el-row height="10px"></el-row>
        <el-row style="padding-top:10px;padding-right:10px">
          <el-col :span="12">
            <el-form-item label="绑定车牌"
                          prop="fPlateCode">
              <el-input v-model="cardPay.fPlateCode"
                        style="width:100%"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="充值时间(小时)"
                          prop="fPaySecs">
              <el-input v-model="cardPay.fPaySecs"
                        style="width:100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="padding-right:10px">
          <el-col :span="12">
            <el-form-item label="起始时间"
                          prop="fBatStartTime">
              <el-date-picker v-model="cardPay.fBatStartTime"
                              style="width:100%"
                              type="date"
                              placeholder="选择起始时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间"
                          prop="fBatEndTime">
              <el-date-picker v-model="cardPay.fBatEndTime"
                              type="date"
                              style="width:100%"
                              placeholder="选择结束时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="padding-right:10px">
          <el-col :span="24">
            <el-form-item label="备注"
                          prop="fRemark">
              <el-input v-model="cardPay.fRemark"
                        style="width:100%"
                        type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   :loading="save_loading"
                   @click="submit('ruleForm')">{{save_msgs}}</el-button>
        <el-button @click="dialogFormVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="dialogFillDurationTitle"
               top="20vh"
               width="50%"
               v-dialogDrag
               :visible.sync="dialogFormFillDurationVisible">
      <el-form :inline="true">
      <el-row style="padding-left:10px;padding-top:6px">
        <el-form :inline="true"
                class="pageSearch">
          <el-form-item label="关键字::">
            <el-input placeholder="请输入车牌号/车主姓名"
                      v-model="searchReaKeyWord"
                      class="input-with-select">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                      icon="el-icon-search"
                      size="small"
                      @click="echallCardReaQuery">查询</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <el-row style="padding-left:10px;padding-right:10px;padding-top:8px">
         <el-table :data="cardFillDurationList"
                      border
                      v-loading="loading"
                      highlight-current-row
                      style="width: 100%"
                      :height="tableDetailHeight"
                      ref="singleTable">
              <el-table-column type="index"
                               width="50"
                               label="序号"
                               :index="indexMethod">
              </el-table-column>
              <el-table-column prop="fOpLastTimeTitle"
                               width="150"
                               label="充值时间">
              </el-table-column>
              <!--<el-table-column prop="fCustNo"
                               width="80"
                               label="客户编号">
              </el-table-column>
              <el-table-column prop="fCustName"
                               width="200"
                               label="客户名称">
              </el-table-column>-->
              <el-table-column prop="fCardName"
                               width="100"
                               label="车主姓名">
              </el-table-column>
              <el-table-column prop="fPlateCode"
                               width="100"
                               label="车牌号码">
              </el-table-column>
              <el-table-column prop="fDurationsTitle"
                               width="130"
                               align="right"
                               label="充值时数（小时）">
              </el-table-column>
              <el-table-column prop="fRemark"
                               label="备注">
              </el-table-column>
            </el-table>
      </el-row>
      <el-row style="padding-bottom:10px;" class="pagination">
        <el-col :span="24">
          <div class="block">
            <span class="demonstration"></span>
            <el-pagination background
                          @size-change="handleSizeReaChange"
                          :current-page.sync="pageReaNo"
                          @current-change="handleReaPage"
                          :page-size="pageReaSize"
                          :page-sizes="[10, 20, 50, 100]"
                          layout="total,sizes, prev, pager, next, jumper"
                          :total="totalRea"
                          v-if="totalRea>0">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
      </el-form>
    </el-dialog>
    <el-dialog :title="dialogInOutTitle"
               top="20vh"
               width="58%"
               v-dialogDrag
               :visible.sync="dialogFormInOutVisible">
      <el-form :inline="true">
      <el-row  style="padding-left:10px;padding-top:3px">
        <el-form :inline="true"
                class="pageSearch">
          <el-form-item label="关键字::">
            <el-input placeholder="请输入车牌号/场库名称"
                      v-model="searchInOutKeyWord"
                      class="input-with-select">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                      icon="el-icon-search"
                      size="small"
                      @click="echallCardInOutQuery">查询</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <el-row style="padding-left:10px;padding-right:10px;padding-top:8px">
         <el-table :data="ehallCardInOutList"
                      border
                      v-loading="loading"
                      highlight-current-row
                      style="width: 100%"
                      :height="tableDetailHeight"
                      ref="singleTable">
              <el-table-column type="index"
                               width="50"
                               label="序号"
                               :index="indexMethod">
              </el-table-column>
              <el-table-column prop="fPlateCode"
                               width="90"
                               label="车牌号码">
              </el-table-column>
              <el-table-column prop="fOpLastTimeTitle"
                               width="150"
                               label="最后更新时间">
              </el-table-column>
              <el-table-column prop="fInTimeTitle"
                               width="150"
                               label="进场时间">
              </el-table-column>
              <el-table-column prop="fInParkName"
                               width="100"
                               label="场库名称">
              </el-table-column>
              <el-table-column prop="fInChnlName"
                               width="110"
                               label="进场通道">
              </el-table-column>
              <el-table-column prop="fOutTimeTitle"
                               width="150"
                               label="出场时间">
              </el-table-column>
              <el-table-column prop="fOutChnlName"
                               width="110"
                               label="出场通道">
              </el-table-column>
              <el-table-column prop="fTotalSecsTitle"
                               width="90"
                               align="right"
                               label="停车时长">
              </el-table-column>
              <el-table-column prop="IsAddTitle"
                               width="115"
                               label="类型">
              </el-table-column>
              <el-table-column prop="fFrontDurationTitle"
                               width="115"
                               align="right"
                               label="扣前/新增时数">
              </el-table-column>
              <el-table-column prop="fPaySecsTitle"
                               width="115"
                               align="right"
                               label="扣除/新增时数">
              </el-table-column>
              <el-table-column prop="fAfterDurationTitle"
                               width="115"
                               align="right"
                               label="扣后/新增时数">
              </el-table-column>
              <el-table-column prop="fRemark"
                               width="115"
                               label="备注">
              </el-table-column>
            </el-table>
      </el-row>
      <el-row style="padding-bottom:10px;" class="pagination">
        <el-col :span="24">
          <div class="block">
            <span class="demonstration"></span>
            <el-pagination background
                          @size-change="handleSizeInOutChange"
                          :current-page.sync="pageInOutNo"
                          @current-change="handleInOutPage"
                          :page-size="pageInOutSize"
                          :page-sizes="[10, 20, 50, 100]"
                          layout="total,sizes, prev, pager, next, jumper"
                          :total="totalInOut"
                          v-if="totalInOut>0">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
      </el-form>
    </el-dialog>
    <el-dialog :title="dialogAddOrDedDurationTitle"
               top="20vh"
               width="40%"
               v-dialogDrag
               :visible.sync="dialogAddOrDedDurationFormVisible">
      <el-form :model="cardPayAddOrDedDuration"
               :rules="rulesAddOrDedDuration"
               ref="ruleFormAddOrDedDuration"
               label-width="115px">
        <el-row height="10px"></el-row>
        <el-row style="padding-top:10px;padding-right:10px">
          <el-col :span="12" style="display:none">
            <el-form-item label="绑定车牌"
                          prop="fPlateCode">
              <el-input v-model="cardPayAddOrDedDuration.fPlateCode"
                        style="width:100%"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="加/减时数类型"
                          prop="fType">
              <el-select v-model="cardPayAddOrDedDuration.fType"
                           filterable
                           sstyle="width: 100%">
                            <el-option
                            v-for="item in typeOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                      </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="加/减时数(小时)"
                          prop="fPaySecs">
              <el-input v-model="cardPayAddOrDedDuration.fPaySecs"
                        style="width:100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="padding-right:10px">
          <el-col :span="24">
            <el-form-item label="备注"
                          prop="fRemark">
              <el-input v-model="cardPayAddOrDedDuration.fRemark"
                        style="width:100%"
                        type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   :loading="save_loading"
                   @click="submitAddOrDedDuration('ruleFormAddOrDedDuration')">{{save_msgs}}</el-button>
        <el-button @click="dialogAddOrDedDurationFormVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <carInfoView ref="child"
                 reportActiveName="cardList"
                 :type="2"></carInfoView>
  </div>
</template>

<script>
import carInfoView from '../../components/carInfoView'
import { mapActions } from 'vuex'
export default {
  components: { carInfoView },
  name: 'fuDanEhallCard',
  data () {
    var validateInt = (rule, value, callback) => {
      if ((value || '').trim().length > 0) {
        if (!/^[0-9]+$/.test(value)) {
          callback(new Error('请填写正整数'))
        }
      }
      callback()
    }
    var valInt = (rule, value, callback) => {
      if (!/^[0-9]+$/.test(value)) {
        callback(new Error('请填写正整数'))
      }
      callback()
    }
    return {
      save_loading: false,
      save_msg: '保存',
      save_msgs: '保存',
      is_edit: false,
      is_del: false,
      is_export: false,
      is_bind: false,
      is_recharge: false,
      is_addOrDedFDuration: false,
      export_msg: '导出',
      export_loading: false,
      sync_loading: false,
      cardActiveName: 'cardList',
      loading: false,
      searchKeyWord: '',
      searchInOutKeyWord: '',
      searchReaKeyWord: '',
      effectiveVehicle: false,
      tableHeight: 0,
      tableDetailHeight: 0,
      choiceCusts: [],
      offlineCusts: [],
      choiceGroups: [],
      cardList: [],
      synCardList: [],
      cardFillDurationList: [],
      ehallCardInOutList: [],
      selCustID: '',
      fGrpID: '',
      selfGroupID: '',
      pageSize: 20,
      pageNo: 1,
      pageInOutSize: 20,
      pageReaSize: 20,
      feHallIDTemp: '',
      feHallIDReaTemp: '',
      pageInOutNo: 1,
      pageReaNo: 1,
      total: 0,
      totalInOut: 0,
      totalRea: 0,
      ehallCard: {
        feHallID: 0,
        edit: false,
        fGrpID: '',
        fPGrpID: '',
        fGrpName: '',
        bindCusts: [],
        cardBindChannelList: [],
        operateFlag: '',
        fPlateCode: '',
        fCardName: '',
        fCardPhone: '',
        fCardCreNo: '',
        fFirUnit: '',
        fSecUnit: '',
        fThiUnit: '',
        fBatStartTime: '',
        fBatEndTime: '',
        fCarTypeID: '',
        fDuration: '2500',
        fRemark: ''
      },
      groupRules: {
        fPlateCode: [
          { required: true, message: '请输入车牌号码', trigger: 'change' }
        ],
        fCardName: [
          { required: true, message: '请输入车主名称', trigger: 'change' }
        ],
        fFirUnit: [
          { required: true, message: '请输入一级单位', trigger: 'change' }
        ],
        fSecUnit: [
          { required: true, message: '请输入二级单位', trigger: 'change' }
        ],
        fBatStartTime: [
          { required: true, message: '请输入起始时间', trigger: 'change' }
        ],
        fBatEndTime: [
          { required: true, message: '请输入结束时间', trigger: 'change' }
        ],
        fCarTypeID: [
          { required: true, message: '请输选择车辆类型', trigger: 'change' }
        ],
        fDuration: [
          { required: true, message: '请输入停车时数', trigger: 'change' },
          { validator: valInt, trigger: 'blur' }
        ]
      },
      groupIsEdit: false,
      groupIsEdits: false,
      dialogGroupFormVisible: false,
      dialogSetChnlFormVisible: false,
      carTypeList: [],
      typeOptions: [{
        value: '0',
        label: '增加'
      }, {
        value: '1',
        label: '扣除'
      }],
      options1: [{
        value: '1',
        label: '大型客车'
      }, {
        value: '2',
        label: '牵引车'
      }, {
        value: '3',
        label: '城市公交车'
      }, {
        value: '4',
        label: '中型客车'
      }, {
        value: '5',
        label: '大型货车'
      }, {
        value: '6',
        label: '小型汽车'
      }, {
        value: '7',
        label: '小型自动挡汽车'
      }, {
        value: '8',
        label: '低速载货汽车'
      }],
      cardPayAddOrDedDuration: {
        feHallID: '',
        fPlateCode: '',
        fPaySecs: '',
        fType: '',
        fDuration: '',
        fRemark: ''
      },
      cardPay: {
        feHallID: '',
        fPlateCode: '',
        fPaySecs: '',
        fBatStartTime: '',
        fBatEndTime: '',
        fRemark: ''
      },
      dialogAddOrDedDurationTitle: '',
      dialogTitle: '',
      dialogFillDurationTitle: '',
      dialogInOutTitle: '',
      dialogFormVisible: false,
      dialogAddOrDedDurationFormVisible: false,
      dialogFormFillDurationVisible: false,
      dialogFormInOutVisible: false,
      rules: {
        fPaySecs: [
          { required: true, message: '请填写购买时间(小时)', trigger: 'blur' },
          { validator: validateInt, trigger: 'blur' }
        ],
        fBatStartTime: [
          { required: true, message: '请选择起始时间', trigger: 'change' }
        ],
        fBatEndTime: [
          { required: true, message: '请选择结束时间', trigger: 'change' }
        ]
      },
      rulesAddOrDedDuration: {
        fPaySecs: [
          { required: true, message: '请填写加减时数(小时)', trigger: 'blur' },
          { validator: validateInt, trigger: 'blur' }
        ],
        fType: [
          { required: true, message: '请选择加减时数类型', trigger: 'blur' }
        ]
      },
      leftCust: {},
      rightCust: {},
      bindQueryInput: '',
      unbindQueryInput: '',
      unbindCustsUI: [],
      bindCustsUI: [],
      unbindCusts: [],
      leftChnl: {},
      rightChnl: {},
      bindChannelName: '',
      unbindChannelName: '',
      cardUnBindChannelListUI: [],
      cardBindChannelListUI: [],
      cardUnBindChannelList: []
    }
  },
  methods: {
    ...mapActions([
      'getCardGroupByCustId', 'getCustByGroup', 'getEhallCardListAsync', 'saveEhallCard', 'saveEhallCardSetChnl', 'ehallCardRecharge', 'ehallCardAddOrDedDuration', 'deleteEhallCard', 'getEhallCardFillDurationList', 'getEhallCardInOustList', 'getEhallCardGroupCust', 'getEhallCardDefaultSetChnlList', 'getCardByQuery', 'loadCardOtherList', 'getParkList', 'saveCard', 'getCurrentUserPers', 'cardDataTemplate',
      'deleteCard', 'synCardById', 'setCardStatus', 'loadCardTypeList', 'loadCarTypeList', 'getRechargeList', 'getCardPayList', 'getCarPresnetList', 'cardUpload', 'importCardData', 'exportCardData'
    ]),
    leftAllChlBtnClick () {
      for (let i = 0; i < this.cardUnBindChannelListUI.length; i++) {
        this.cardUnBindChannelList.splice(this.cardUnBindChannelList.indexOf(this.cardUnBindChannelListUI[i]), 1)
        if (this.ehallCard.cardBindChannelList.indexOf(this.cardUnBindChannelListUI[i]) === -1) {
          this.ehallCard.cardBindChannelList.push(this.cardUnBindChannelListUI[i])
        }
      }
      this.cardBindChannelListUI = this.copyArr(this.ehallCard.cardBindChannelList)
      this.cardUnBindChannelListUI = []
    },
    leftChnlBtnClick () {
      if (!this.rightChnl || !this.rightChnl.fParkID || !this.rightChnl.fChnlID) {
        return
      }
      this.ehallCard.cardBindChannelList.push(this.rightChnl)
      this.cardBindChannelListUI.push(this.rightChnl)
      this.cardUnBindChannelListUI.splice(this.cardUnBindChannelListUI.indexOf(this.rightChnl), 1)
      this.cardUnBindChannelList.splice(this.cardUnBindChannelList.indexOf(this.rightChnl), 1)
    },
    rightChnlBtnClick () {
      if (!this.leftChnl || !this.leftChnl.fParkID || !this.leftChnl.fChnlID) {
        return
      }
      this.cardUnBindChannelList.push(this.leftChnl)
      this.cardUnBindChannelListUI.push(this.leftChnl)
      this.cardBindChannelListUI.splice(this.cardBindChannelListUI.indexOf(this.leftChnl), 1)
      this.ehallCard.cardBindChannelList.splice(this.ehallCard.cardBindChannelList.indexOf(this.leftChnl), 1)
    },
    rightAllChlBtnClick () {
      for (let i = 0; i < this.cardBindChannelListUI.length; i++) {
        this.ehallCard.cardBindChannelList.splice(this.ehallCard.cardBindChannelList.indexOf(this.cardBindChannelListUI[i]), 1)
        if (this.cardUnBindChannelList.indexOf(this.cardBindChannelListUI[i]) === -1) {
          this.cardUnBindChannelList.push(this.cardBindChannelListUI[i])
        }
      }
      this.cardUnBindChannelListUI = this.copyArr(this.cardUnBindChannelList)
      this.cardBindChannelListUI = []
    },
    bindParkQuery () {
      let tmp = this.bindChannelName.trim().toLowerCase()
      if (tmp.replace(/(^s*)|(s*$)/g, '').length === 0) {
        this.cardBindChannelListUI = this.copyArr(this.ehallCard.cardBindChannelList)
        return
      }
      this.cardBindChannelListUI = this.ehallCard.cardBindChannelList.filter(r => r.ParkNameWithChnlName.toLowerCase().indexOf(tmp) > -1)
    },
    unbindParkQuery () {
      let tmp = this.unbindChannelName.trim().toLowerCase()
      if (tmp.replace(/(^s*)|(s*$)/g, '').length === 0) {
        this.cardUnBindChannelListUI = this.copyArr(this.cardUnBindChannelList)
        return
      }
      this.cardUnBindChannelListUI = this.cardUnBindChannelList.filter(r => r.ParkNameWithChnlName.toLowerCase().indexOf(tmp) > -1)
    },
    unbindChnlChange (chnl) {
      this.rightChnl = chnl
    },
    bindChnlChange (chnl) {
      this.leftChnl = chnl
    },
    uploadSuccess (response, file, fileList) {
      console.log('file upload success')
    },
    exportData () {
      // if ((this.selCustID || '').trim().length <= 0) {
      //   this.$message.error('提示：请先选择客户')
      //   return false
      // }
      this.export_loading = true
      this.export_msg = '导出中……'
      var custArr = (this.choiceCusts || []).filter((item) => {
        return item.fCustID === this.selCustID
      })
      var fileName = custArr.length > 0 ? custArr[0].unionName : ''
      this.getEhallCardListAsync({
        fCustID: this.selCustID,
        fGroupID: this.selfGroupID,
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        searchKeyWord: this.searchKeyWord,
        effectiveVehicle: this.effectiveVehicle,
        cardActiveName: this.cardActiveName,
        exportData: 1
      }).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_外协车辆数据.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    handleInfo (row) {
      this.r = {
        isOld: false,
        tyPe: 2,
        isSync: false,
        id: row.fBusID,
        fBusID: row.fBusID,
        fCustID: row.fCustID
      }
      this.$refs.child.handleInfo(this.r)
    },
    tabClick () {
      this.pageNo = 1
      this.total = 0
      this.initData()
    },
    cardQuery () {
      this.initData()
      // let obj = {}
      // obj = this.choiceCusts.find((item) => {
      //   return item.fCustID === this.selCustID
      // })
      // this.custName = obj.unionName
    },
    echallCardInOutQuery () {
      this.rowTemp = {
        feHallID: this.feHallIDTemp
      }
      this.initInOutData(this.rowTemp)
    },
    echallCardReaQuery () {
      this.rowTemp = {
        feHallID: this.feHallIDReaTemp
      }
      this.initReaData(this.rowTemp)
    },
    leftAllBtnClick () {
      for (let i = 0; i < this.unbindCustsUI.length; i++) {
        this.unbindCusts.splice(this.unbindCusts.indexOf(this.unbindCustsUI[i]), 1)
        if (this.ehallCard.bindCusts.indexOf(this.unbindCustsUI[i]) === -1) {
          this.ehallCard.bindCusts.push(this.unbindCustsUI[i])
        }
      }
      this.bindCustsUI = this.copyArr(this.ehallCard.bindCusts)
      this.unbindCustsUI = []
    },
    copyArr (arr) { // 深层copy
      let res = []
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i])
      }
      return res
    },
    leftBtnClick () {
      if (!this.rightCust || !this.rightCust.fCustID) {
        return
      }
      this.bindCustsUI.push(this.rightCust)
      this.ehallCard.bindCusts.push(this.rightCust)
      this.unbindCustsUI.splice(this.unbindCustsUI.indexOf(this.rightCust), 1)
      this.unbindCusts.splice(this.unbindCusts.indexOf(this.rightCust), 1)
    },
    rightBtnClick () {
      if (!this.leftCust || !this.leftCust.fCustID) {
        return
      }
      this.unbindCustsUI.push(this.leftCust)
      this.unbindCusts.push(this.leftCust)
      this.bindCustsUI.splice(this.bindCustsUI.indexOf(this.leftCust), 1)
      this.ehallCard.bindCusts.splice(this.ehallCard.bindCusts.indexOf(this.leftCust), 1)
    },
    rightAllBtnClick () {
      for (let i = 0; i < this.bindCustsUI.length; i++) {
        this.ehallCard.bindCusts.splice(this.ehallCard.bindCusts.indexOf(this.bindCustsUI[i]), 1)
        if (this.unbindCusts.indexOf(this.bindCustsUI[i]) === -1) {
          this.unbindCusts.push(this.bindCustsUI[i])
        }
      }
      this.unbindCustsUI = this.copyArr(this.unbindCusts)
      this.bindCustsUI = []
    },
    bindParkChange (cust) {
      this.leftCust = cust
    },
    unbindParkChange (cust) {
      this.rightCust = cust
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.bindCustsUI.length === 0) {
            this.$message({
              type: 'warning',
              message: '请绑定客户'
            })
            return
          }
          if (this.cardBindChannelListUI.length === 0) {
            this.$message({
              type: 'warning',
              message: '请绑定通道'
            })
            return
          }
          this.save_loading = true
          this.save_msg = '保存中…'
          if (this.ehallCard.fBatStartTime instanceof Date) {
            this.ehallCard.fBatStartTime = this.$dateFormat(this.ehallCard.fBatStartTime, 'yyyy-MM-dd 00:00:00')
          }
          if (this.ehallCard.fBatEndTime instanceof Date) {
            this.ehallCard.fBatEndTime = this.$dateFormat(this.ehallCard.fBatEndTime, 'yyyy-MM-dd 23:59:59')
          }
          if (this.ehallCard.feHallID > 0) {
            this.ehallCard.edit = true
          } else {
            this.ehallCard.edit = false
          }
          this.saveEhallCard(this.ehallCard).then(res => {
            this.save_loading = false
            this.save_msg = '保存'
            if (res && res.data) {
              var data = res.data
              if (data.IsOk) {
                this.dialogGroupFormVisible = false
                this.initData()
                this.$message.success('外协车辆数据保存成功')
              } else {
                this.$message.error(data.Msg)
              }
            }
          })
        }
      })
    },
    submitSetChnlForm (formName) {
      if (this.cardBindChannelListUI.length === 0) {
        this.$message({
          type: 'warning',
          message: '请绑定通道'
        })
        return
      }
      this.save_loading = true
      this.save_msg = '保存中…'
      this.saveEhallCardSetChnl(this.ehallCard).then(res => {
        this.save_loading = false
        this.save_msg = '保存'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.dialogSetChnlFormVisible = false
            this.initData()
            this.$message.success('外协车辆默认进场通道设置成功')
          } else {
            this.$message.error(data.Msg)
          }
        }
      })
    },
    submitAddOrDedDuration (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save_loading = true
          this.save_msgs = '保存中…'
          this.ehallCardAddOrDedDuration(this.cardPayAddOrDedDuration).then(res => {
            this.save_loading = false
            this.save_msgs = '保存'
            if (res && res.data) {
              var data = res.data
              if (data.IsOk) {
                this.dialogAddOrDedDurationFormVisible = false
                this.initData()
                this.$message.success('外协车辆数据充值成功')
              } else {
                this.$message.error(data.Msg)
              }
            }
          })
        }
      })
    },
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.formDisabled) { return }
          if (this.cardPay.fBatStartTime instanceof Date) {
            this.cardPay.fBatStartTime = this.$dateFormat(this.cardPay.fBatStartTime, 'yyyy-MM-dd 00:00:00')
          }
          if (this.cardPay.fBatEndTime instanceof Date) {
            this.cardPay.fBatEndTime = this.$dateFormat(this.cardPay.fBatEndTime, 'yyyy-MM-dd 23:59:59')
          }
          this.save_loading = true
          this.save_msgs = '保存中…'
          this.ehallCardRecharge(this.cardPay).then(res => {
            this.save_loading = false
            this.save_msgs = '保存'
            if (res && res.data) {
              var data = res.data
              if (data.IsOk) {
                this.dialogFormVisible = false
                this.initData()
                this.$message.success('外协车辆数据充值成功')
              } else {
                this.$message.error(data.Msg)
              }
            }
          })
        }
      })
    },
    bindQuery () {
      let tmp = this.bindQueryInput.trim().toLowerCase()
      if (tmp.replace(/(^s*)|(s*$)/g, '').length === 0) {
        this.bindCustsUI = this.copyArr(this.ehallCard.bindCusts)
        return
      }
      this.bindCustsUI = this.ehallCard.bindCusts.filter(r => r.unionName.toLowerCase().indexOf(tmp) > -1)
    },
    unbindQuery () {
      let tmp = this.unbindQueryInput.trim().toLowerCase()
      if (tmp.replace(/(^s*)|(s*$)/g, '').length === 0) {
        this.unbindCustsUI = this.copyArr(this.unbindCusts)
        return
      }
      this.unbindCustsUI = this.unbindCusts.filter(r => { return r.unionName.toLowerCase().indexOf(tmp) > -1 })
    },
    initPerAndCust (param) {
      this.unbindCusts = []
      this.unbindCustsUI = []
      this.ehallCard.bindCusts = []
      this.bindCustsUI = []
      this.cardUnBindChannelList = []
      this.cardUnBindChannelListUI = []
      this.ehallCard.cardBindChannelList = []
      this.cardBindChannelListUI = []
      this.getEhallCardGroupCust({ fGrpID: param.fGrpID, fIsAdd: param.fIsAdd, fIsEhallCust: param.fIsEhallCust, feHallID: param.feHallID, isAdd: param.isAdd }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.unbindCusts = data.Data.optionalCustList || []
              this.unbindCustsUI = this.copyArr(this.unbindCusts)
              this.ehallCard.bindCusts = data.Data.bindCustList || []
              this.bindCustsUI = this.copyArr(this.ehallCard.bindCusts)
              this.cardUnBindChannelList = data.Data.optionalChnlList || []
              this.cardUnBindChannelListUI = this.copyArr(this.cardUnBindChannelList)
              this.ehallCard.cardBindChannelList = data.Data.bindChnlList || []
              this.cardBindChannelListUI = this.copyArr(this.ehallCard.cardBindChannelList)
            }
          }
        }
      })
      this.dialogGroupFormVisible = true
    },
    setEhallCardDefaultChnl () {
      setTimeout(() => {
        if (this.$refs['ehallCardSetChnlForm']) {
          this.$refs['ehallCardSetChnlForm'].clearValidate()
        }
      }, 50)
      this.ehallCard = {
        cardBindChannelList: [],
        operateFlag: '设置默认进场通道'
      }
      this.cardUnBindChannelList = []
      this.cardUnBindChannelListUI = []
      this.ehallCard.cardBindChannelList = []
      this.cardBindChannelListUI = []
      this.getEhallCardDefaultSetChnlList({ }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.cardUnBindChannelList = data.Data.optionalChnlList || []
              this.cardUnBindChannelListUI = this.copyArr(this.cardUnBindChannelList)
              this.ehallCard.cardBindChannelList = data.Data.bindChnlList || []
              this.cardBindChannelListUI = this.copyArr(this.ehallCard.cardBindChannelList)
            }
          }
        }
      })
      this.dialogSetChnlFormVisible = true
    },
    addSyncEhallCard () {
      setTimeout(() => {
        if (this.$refs['ehallCardForm']) {
          this.$refs['ehallCardForm'].clearValidate()
        }
      }, 50)
      this.groupIsEdit = true
      this.groupIsEdits = true
      var today = new Date()
      this.ehallCard = {
        feHallID: 0,
        edit: false,
        bindCusts: [],
        cardBindChannelList: [],
        operateFlag: '新增外协车辆',
        fCarTypeID: '1',
        fBatStartTime: new Date(),
        fBatEndTime: new Date(today.setMonth(today.getMonth() + 1)),
        fGrpID: '',
        fPGrpID: '',
        fGrpName: '',
        fPlateCode: '',
        fCardName: '',
        fCardPhone: '',
        fCardCreNo: '',
        fFirUnit: '',
        fSecUnit: '',
        fThiUnit: '',
        fDuration: '2500',
        fRemark: ''
      }
      this.dialogGroupFormVisible = true
      this.initPerAndCust({ fGrpID: this.fGrpID, fIsAdd: true, fIsEhallCust: false, feHallID: 0, isAdd: true })
    },
    editEhallCard (index, row) {
      setTimeout(() => {
        if (this.$refs['ehallCardForm']) {
          this.$refs['ehallCardForm'].clearValidate()
        }
      }, 50)
      this.ehallCard = {}
      this.ehallCard = row
      this.ehallCard.edit = true
      this.groupIsEdit = true
      this.groupIsEdits = false
      this.ehallCard.operateFlag = '编辑外协车辆【' + row.fPlateCode + '】'
      this.ehallCard.fCarTypeID = row.fCarTypeID
      this.ehallCard.feHallID = row.feHallID
      // var today = new Date()
      // this.ehallCard.fBatStartTime = new Date()
      // this.ehallCard.fBatEndTime = new Date(today.setMonth(today.getMonth() + 1))
      this.ehallCard.fBatStartTime = row.fBatStartTimeTitle
      this.ehallCard.fBatEndTime = row.fBatEndTimeTitle
      this.dialogGroupFormVisible = true
      console.log('13')
      this.initPerAndCust({ fGrpID: row.fGrpID, fIsAdd: false, fIsEhallCust: true, feHallID: row.feHallID, isAdd: false })
    },
    rechargeCard (index, row) {
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].clearValidate()
      }
      this.dialogTitle = row.fPlateCode + '-充值'
      var fBatStartTime = new Date(row.ncdEndTime)
      var fBatEndTime = new Date(row.fBatEndTimeTitle)
      fBatEndTime = new Date(fBatEndTime.setMonth(fBatEndTime.getMonth() + 1))
      this.cardPay = {
        feHallID: row.feHallID,
        fPlateCode: row.fPlateCode,
        fPaySecs: 0,
        fBatStartTime: this.$dateFormat(fBatStartTime, 'yyyy-MM-dd 00:00:00'),
        fBatEndTime: this.$dateFormat(fBatEndTime, 'yyyy-MM-dd 23:59:59'),
        fRemark: ''
      }
      this.dialogFormVisible = true
    },
    addOrDedFDuration (index, row) {
      if (this.$refs['ruleFormAddOrDedDuration']) {
        this.$refs['ruleFormAddOrDedDuration'].clearValidate()
      }
      this.dialogAddOrDedDurationTitle = row.fPlateCode + '-加减时数'
      this.cardPayAddOrDedDuration = {
        feHallID: row.feHallID,
        fPlateCode: row.fPlateCode,
        fDuration: row.fDuration,
        fType: '0',
        fPaySecs: '',
        fRemark: ''
      }
      this.dialogAddOrDedDurationFormVisible = true
    },
    rechargeEhallCardRecord (index, row) {
      this.searchReaKeyWord = ''
      this.dialogFillDurationTitle = row.fPlateCode + '-充值记录'
      this.feHallIDReaTemp = row.feHallID
      this.initReaData(row)
      this.dialogFormFillDurationVisible = true
    },
    ehallCardInOutRecord (index, row) {
      this.searchInOutKeyWord = ''
      this.feHallIDTemp = row.feHallID
      this.dialogInOutTitle = row.fPlateCode + '-扣时/新增时数明细'
      this.initInOutData(row)
      this.dialogFormInOutVisible = true
    },
    viewCard (row) {
      setTimeout(() => {
        if (this.$refs['ehallCardForm']) {
          this.$refs['ehallCardForm'].clearValidate()
        }
      }, 50)
      this.ehallCard = {}
      this.ehallCard = row
      this.groupIsEdit = false
      this.groupIsEdits = false
      this.ehallCard.operateFlag = '查看外协车辆【' + row.fPlateCode + '】'
      // var today = new Date()
      // this.ehallCard.fBatStartTime = new Date()
      // this.ehallCard.fBatEndTime = new Date(today.setMonth(today.getMonth() + 1))
      this.ehallCard.fBatStartTime = row.fBatStartTimeTitle
      this.ehallCard.fBatEndTime = row.fBatEndTimeTitle
      this.dialogGroupFormVisible = true
      console.log('13')
      this.initPerAndCust({ fGrpID: row.fGrpID, fIsAdd: false, fIsEhallCust: true, feHallID: row.feHallID, isAdd: false })
    },
    deleteEhallCardClient (index, row) {
      this.$confirm('删除外协车【' + row.fPlateCode + '】记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteEhallCard({ feHallID: row.feHallID }).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.$message.success('外协车辆数据删除成功')
              this.initData()
            } else {
              this.$message.error(data.Msg)
            }
          }
        })
      })
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 230
      obj.tableHeight = clientHeight
    },
    setDetailTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 560
      obj.tableDetailHeight = clientHeight
    },
    indexMethod (index) {
      return this.pageSize * (this.pageNo - 1) + index + 1
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageNo = index
      this.initData()
    },
    handleSizeInOutChange (value) {
      this.pageInOutSize = value
      this.rowTemp = {
        feHallID: this.feHallIDTemp
      }
      this.initInOutData(this.rowTemp)
    },
    handleInOutPage (index) {
      this.pageInOutNo = index
      this.rowTemp = {
        feHallID: this.feHallIDTemp
      }
      this.initInOutData(this.rowTemp)
    },
    handleSizeReaChange (value) {
      this.pageReaSize = value
      this.rowTemp = {
        feHallID: this.feHallIDReaTemp
      }
      this.initReaData(this.rowTemp)
    },
    handleReaPage (index) {
      this.pageReaNo = index
      this.rowTemp = {
        feHallID: this.feHallIDReaTemp
      }
      this.initReaData(this.rowTemp)
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.fIsDel === '1') {
        return 'warning-row'
      }
      return ''
    },
    tableErrorRowClassName ({ row, rowIndex }) {
      if (row.fIsErr) {
        return 'error-row'
      }
      return ''
    },
    initData () {
      var isSyn = this.cardActiveName === 'synCardList'
      if (isSyn) {
        this.synCardList = []
      } else {
        this.cardList = []
      }
      this.loading = true
      this.getEhallCardListAsync({
        fCustID: this.selCustID,
        fGroupID: this.selfGroupID,
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        searchKeyWord: this.searchKeyWord,
        effectiveVehicle: this.effectiveVehicle,
        cardActiveName: this.cardActiveName,
        exportData: 0
      }).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.total = data.Data.total
              if (isSyn) {
                this.synCardList = data.Data.rows
              } else {
                this.cardList = data.Data.rows
              }
            } else {
              this.$message.error(data.Msg)
            }
          }
        }
      })
    },
    initInOutData (row) {
      this.getEhallCardInOustList({ pageSize: this.pageInOutSize, pageNo: this.pageInOutNo, feHallID: row.feHallID, searchKeyWord: this.searchInOutKeyWord }).then(res => {
        if (res && res.data) {
          let { data } = res
          if (data.IsOk) {
            this.totalInOut = data.Data.total
            this.ehallCardInOutList = data.Data.rows || []
          } else {
            this.$message.error(data.Msg)
          }
        }
      })
    },
    initReaData (row) {
      this.getEhallCardFillDurationList({ pageSize: this.pageReaSize, pageNo: this.pageReaNo, feHallID: row.feHallID, searchKeyWord: this.searchReaKeyWord }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.totalRea = data.Data.total
              this.cardFillDurationList = data.Data.rows || []
            } else {
              this.$message.error(data.Msg)
            }
          }
        }
      })
    },
    changeCust (fCustID) {
      this.selfGroupID = ''
      this.choiceGroups = []
      this.getCardGroupByCustId({ fCustID: fCustID }).then(res => {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let tmpGroups = []
            Object.assign(tmpGroups, data.Data)
            this.choiceGroups = tmpGroups
          }
        }
      })
    }
  },

  watch: {

  },
  computed: {
    ispagination: function () {
      return this.total > this.pageSize
    }
  },
  created () {
    this.getCurrentUserPers({ perTypeId: 1039000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
            this.is_export = data.Data.data.is_export
            this.is_bind = data.Data.data.is_bind
            this.is_recharge = data.Data.data.is_recharge
            this.is_addOrDedFDuration = data.Data.data.is_addOrDedFDuration
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      this.setTableHeight(sizethis)
      this.setDetailTableHeight(sizethis)
    }
    this.getCustByGroup().then(res => {
      if (res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
            if (this.choiceCusts && this.choiceCusts.length === 1) {
              this.selCustID = this.choiceCusts[0].fCustID
              this.fGrpID = this.choiceCusts[0].fGrpID
              this.changeCust(this.selCustID)
            }
            this.offlineCusts = custs.filter(r => r.fCustTypeID === '0') // 封闭式客户
          }
        }
      }
    })
    this.initData()
  },
  updated () {
    this.setTableHeight(this)
    this.setDetailTableHeight(this)
  }
}
</script>

<style>
#fuDanEhallCard .is-disabled .el-input__inner,
#fuDanEhallCard .is-disabled .el-textarea__inner {
  color: #606266;
}
#fuDanEhallCard .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#fuDanEhallCard .el-dialog__title {
  color: white;
}
#fuDanEhallCard .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#fuDanEhallCard .el-dialog__body {
  padding: 5px;
}
#fuDanEhallCard .warning-row {
  color: chocolate;
}
#fuDanEhallCard .error-row {
  color: #fb4545;
}
</style>
<style scoped>
.myCardLableClass .isRed {
  color: #fb4545;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
.curRowInfo {
  margin-top: 10px;
}
.curRowInfo .el-row {
  margin-top: 10px;
}
.dialog-video-wrapper .el-dialog__body {
  padding: 5px;
}
.myel-input__inner {
  height: 20px;
  line-height: 20px;
}
legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 10px;
  line-height: inherit;
  color: #333;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
}
fieldset {
  margin: 0 2px;
  border: 0px solid silver;
}
.el-upload__tip {
  margin-top: 0px;
  color: red;
}
.userGroupEdit .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
.userGroupEdit .el-dialog__title {
  color: white;
}
.userGroupEdit .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
.userGroupEdit .el-dialog__body {
  padding-top: 20px;
  padding-left: 20px;
  padding-left: 20px;
  padding-bottom: 0px;
}
#fuDanEhallCard .userGroupEdit .el-tabs__content {
  height: 400px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/view/card/fuDanEhallCard.vue